export const secondsModalOpen = (timeModalOpened: Date) => {
  const milliSecondsInSecond = 1000
  const timePassedSinceModalOpened = Math.abs(new Date().getTime() - timeModalOpened.getTime())
  const totalSecondsModalOpened = Math.ceil(timePassedSinceModalOpened / milliSecondsInSecond)

  return totalSecondsModalOpened || 0
}
